import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn, FlexRow, FlexRowDiv } from "./common.styles";
import { HXSectionTitle, SemiBoldText, Text } from "./HXDesktopPage.styles";
import Button from "@mui/material/Button";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CircleOutlined from "@mui/icons-material/CircleOutlined";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Lock from "@mui/icons-material/Lock";
import RocketLaunch from "@mui/icons-material/RocketLaunch";
import { svgGradientStyle } from "./SVGGradients";
import { fontWeights } from "healthex-common/weights";
import { HXDialog } from "./HXDialog";
import React from "react";
import { CopyIcon } from "./CopyTextFieldView.styles";
import { HXButton } from "./HXButton";
const maxWidthStyle = css `
    width: 700px;
`;
export const GoLiveContainer = styled(FlexColumn) `
    gap: 32px;
    padding: 40px;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background-color: ${colors.white_main};
`;
export const GoLiveLayout = styled(FlexColumn) `
    ${maxWidthStyle}
    gap: 8px;
`;
export const GoLiveTitle = styled(HXSectionTitle) ``;
export const GoLiveText = styled(Text) ``;
export const GoLiveInviteLayout = styled(FlexRow) `
    ${maxWidthStyle}
    gap: 8px;
    align-items: center;
`;
export const GoLiveInviteButton = styled(Button) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const GoLiveChecklistContainer = styled(FlexColumn) `
    gap: 32px;
`;
export const ProgressBarContainer = styled.div `
    position: relative;
    width: 100%;
    height: 24px;
    overflow: hidden;
`;
export const ProgressBarBackground = styled.div `
    position: absolute;
    width: 100%;
    height: 24px;
    overflow: hidden;
    left: 0px;
    top: 0px;
    background: rgba(7, 20, 32, 0.12);
    border-radius: 100px;
`;
export const ProgressBar = styled(ProgressBarBackground) `
    width: ${(props) => props.progressPercentage};
    background: linear-gradient(135deg, #ffd881 0%, #ff8a2d 100%);
`;
export const GoLiveChecklistItems = styled(FlexColumn) `
    gap: 16px;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
`;
export const GoLiveItemContainer = styled(FlexRowDiv) `
    gap: 8px;
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
    align-items: center;
`;
const iconStyle = css `
    width: 32px;
    height: 32px;
`;
export const GoLiveItemCheckCircleOutline = styled(CheckCircle) `
    color: ${colors.accents_grass};
    ${iconStyle}
`;
export const GoLiveItemCircleOutlined = styled(CircleOutlined) `
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_lighter)};
    ${iconStyle}
`;
export const GoLiveItemChevronRight = styled(ChevronRight) `
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_lighter)};
    ${iconStyle}
`;
export const GoLiveItemRocket = styled(RocketLaunch) `
    ${svgGradientStyle("accents_gradient")}
    ${iconStyle};
`;
export const GoLiveItemLock = styled(Lock) `
    color: ${colors.black_30};
    ${iconStyle}
`;
export const GoLiveItemText = styled(SemiBoldText) `
    color: ${(props) => (props.disabled ? colors.black_lighter : colors.black_main)};
`;
export const GoLiveItemDisabledMessage = styled(GoLiveItemText) `
    color: ${colors.black_30};
    margin-left: 8px;
`;
export const GoLiveCheckListDialog = styled(HXDialog) `
    & .MuiDialogContent-root {
        padding-bottom: 8px;
    }
`;
export const GoLiveDialogChecklistContainer = styled.div `
    margin-top: 16px;
    padding: 24px;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background-color: ${colors.white_background};
`;
export const GoLiveDialogGoHomeContainer = styled(FlexColumn) `
    align-items: end;
    justify-content: center;
    padding-top: 16px;
`;
export const GoLiveDialogGoHomeButton = styled(HXButton).attrs({ text: true }) ``;
export const GoLiveInvitationLinkContainer = styled(FlexColumn) `
    margin-top: 16px;
`;
export const GoLiveInvitationLinkButton = styled(HXButton).attrs({
    startIcon: React.createElement(CopyIcon),
    secondary: true,
}) `
    align-self: stretch;
    justify-content: flex-start;
    font-weight: ${fontWeights.NORMAL};
    background-color: ${colors.white_background};
`;
